/**
 * Provider for saving all list filters for a session
 */
angular.module('impactx.listcache', []).provider('$listCache', function () {
    var self = this;

    this.filterCache = {};
    this.popupFilterCache = {};
    this.booleanFilterCache = {};
    this.deprecatedFilterCache = {};
    this.autocompleteFilterCache = {};
    this.dateFilterCache = {};
    this.dateFiltersCache = {};
    this.specialAutocompleteFieldCache = {};
    this.lastVisitedPage = {};
    self.lastScrollPosition = {};
    this.wasPreFiltered = [];
    self.sortColumnCache = {};


    this.putFilters = function (id, headers) {
        this.filterCache[id] = headers;
    };

    this.putDateFilter = function (id, selectedId) {
        this.dateFilterCache[id] = selectedId;
    };

    this.putPopupFilters = function (id, popFilters) {
        this.popupFilterCache[id] = popFilters;
    };

    this.putBooleanFilters = function (id, boolFilters) {
        this.booleanFilterCache[id] = boolFilters;
    };
    this.putDeprecatedFilter = function (id, deprecatedFilter) {
        this.deprecatedFilterCache[id] = deprecatedFilter;
    };

    this.putAutocompleteFilters = function (id, autocompleteFilters) {
        this.autocompleteFilterCache[id] = autocompleteFilters;
    };

    this.putDateFilters = function (id, dateFilters) {
        this.dateFiltersCache[id] = dateFilters;
    };

    this.putSpecialAutocompleteField = function (id, specialFilter) {
        this.specialAutocompleteFieldCache[id] = specialFilter;
    };

    this.putLastVisitedPageIndex = function (id, lastVisitedPageIndex) {
        this.lastVisitedPage[id] = lastVisitedPageIndex;
    };

    function putLastScrollPosition(id, scrollPosition) {
        self.lastScrollPosition[id] = scrollPosition;
    }

    function putSortColumn(id, sortColumn) {
        self.sortColumnCache[id] = sortColumn;
    }

    function getSortColumn(id) {
        return self.sortColumnCache[id];
    }

    this.getFilters = function (id) {
        return this.filterCache[id];
    };

    this.getDateFilter = function (id) {
        return this.dateFilterCache[id];
    };

    this.getPopupFilters = function (id) {
        return this.popupFilterCache[id];
    };

    this.getBooleanFilters = function (id) {
        return this.booleanFilterCache[id];
    };

    this.getDeprecatedFilter = function (id) {
        return this.deprecatedFilterCache[id];
    };

    this.getAutocompleteFilters = function (id) {
        return this.autocompleteFilterCache[id];
    };

    this.getDateFilters = function (id) {
        return this.dateFiltersCache[id];
    };

    this.getSpecialAutocompleteField = function (id) {
        return this.specialAutocompleteFieldCache[id];
    };

    this.getLastVisitedPageIndex = function (id) {
        return this.lastVisitedPage[id];
    };

    function getLastScrollPosition(id) {
        return self.lastScrollPosition[id];
    }

    this.getWasPreFiltered = function (id) {
        return this.wasPreFiltered ? this.wasPreFiltered[id] : false;
    };

    this.setWasPreFiltered = function (id) {
        if (!this.wasPreFiltered) {
            this.wasPreFiltered = [];
        }
        this.wasPreFiltered[id] = true;
    };

    this.removeWasPreFiltered = function (id) {
        if (this.wasPreFiltered) {
            this.wasPreFiltered[id] = false;
        }
    };

    this.remove = function (id) {
        this.filterCache[id] = undefined;
        this.dateFilterCache[id] = {};
        this.dateFiltersCache[id] = {};
        this.popupFilterCache[id] = {};
        this.booleanFilterCache[id] = {};
        this.deprecatedFilterCache[id] = {};
        this.autocompleteFilterCache[id] = {};
        this.specialAutocompleteFieldCache[id] = {};
        this.lastVisitedPage[id] = undefined;
        self.lastScrollPosition[id] = {};
        if (!this.wasPreFiltered) {
            this.wasPreFiltered = [];
        }
        this.wasPreFiltered[id] = false;
    };

    this.removeAll = function () {
        this.filterCache = [];
        this.popupFilterCache = {};
        this.dateFilterCache = {};
        this.dateFiltersCache = {};
        this.booleanFilterCache = {};
        this.deprecatedFilterCache = {};
        this.autocompleteFilterCache = {};
        this.specialAutocompleteFieldCache = {};
        this.lastVisitedPage = [];
        self.lastScrollPosition = {};
        this.wasPreFiltered = [];
    };

    this.$get = function () {
        return {
            filterCache: this.filterCache,
            dateFilterCache: this.dateFilterCache,
            putFilters: this.putFilters,
            putDateFilter: this.putDateFilter,
            getFilters: this.getFilters,
            getDateFilter: this.getDateFilter,
            remove: this.remove,
            putPopupFilters: this.putPopupFilters,
            getPopupFilters: this.getPopupFilters,
            popupFilterCache: this.popupFilterCache,
            putBooleanFilters: this.putBooleanFilters,
            getBooleanFilters: this.getBooleanFilters,
            booleanFilterCache: this.booleanFilterCache,
            putAutocompleteFilters: this.putAutocompleteFilters,
            getAutocompleteFilters: this.getAutocompleteFilters,
            putDateFilters: this.putDateFilters,
            getDateFilters: this.getDateFilters,
            dateFiltersCache: this.dateFiltersCache,
            putSpecialAutocompleteField: this.putSpecialAutocompleteField,
            getSpecialAutocompleteField: this.getSpecialAutocompleteField,
            specialAutocompleteFieldCache: this.specialAutocompleteFieldCache,
            autocompleteFilterCache: this.autocompleteFilterCache,
            putDeprecatedFilter: this.putDeprecatedFilter,
            getDeprecatedFilter: this.getDeprecatedFilter,
            putLastVisitedPage: this.putLastVisitedPageIndex,
            getLastVisitedPage: this.getLastVisitedPageIndex,
            putLastScrollPosition: putLastScrollPosition,
            getLastScrollPosition: getLastScrollPosition,
            setWasPreFiltered: this.setWasPreFiltered,
            getWasPreFiltered: this.getWasPreFiltered,
            removeWasPreFiltered: this.removeWasPreFiltered,
            lastVisitedPage: this.lastVisitedPage,
            deprecatedFilterCache: this.deprecatedFilterCache,
            removeAll: this.removeAll,
            putSortColumn: putSortColumn,
            getSortColumn: getSortColumn
        }
    }
});